import { render, staticRenderFns } from "./BaseFormPopup.vue?vue&type=template&id=5154272a"
import script from "./BaseFormPopup.vue?vue&type=script&lang=js"
export * from "./BaseFormPopup.vue?vue&type=script&lang=js"
import style0 from "./BaseFormPopup.vue?vue&type=style&index=0&id=5154272a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports